import { create, destroy, exportXls, get, getAll, update } from "api/assetLead";
import { replace } from "connected-react-router";
import { saveAs } from "file-saver";
import moment from "moment";

import range from "utils/deals/range";
import { createUrlParams } from "utils/urlParams";

export const getAssetLeads = (portfolioIDs, status) => ({
  type: "ASSET_LEADS_GET",
  payload: getAll(portfolioIDs, status),
});

export const getAssetLead = (id) => ({
  type: "ASSET_LEAD_GET",
  payload: get(id),
});

export const createAssetLead = (assetLead) => ({
  type: "ASSET_LEAD_CREATE",
  payload: create({
    ...assetLead,
    size: range(assetLead.size),
  }),
});

export const updateAssetLead = (assetLead) => ({
  type: "ASSET_LEAD_UPDATE",
  payload: update({
    ...assetLead,
    size: range(assetLead.size),
  }),
});

export const deleteAssetLead = (assetLeadID) => ({
  type: "ASSET_LEAD_DELETE",
  payload: destroy(assetLeadID),
});

export const sortAssetLeads = (key, dir) => ({
  type: "ASSET_LEADS_SORT",
  payload: { key, dir },
});

export const filterAssetLeads = (filters) => (dispatch, getState) => {
  const portfolioIDs = getState().selectedPortfolioIDs;
  dispatch(replace(`/asset_leads${createUrlParams({ ...filters, portfolioIDs }, "indices")}`));

  return dispatch({
    type: "ASSET_LEADS_FILTER",
    meta: { filters },
  });
};

export const exportAssetLeads = () => (dispatch, getState) => {
  const portfolioIDs = getState().selectedPortfolioIDs;

  return dispatch({
    type: "ASSET_LEADS_EXPORT",
    payload: exportXls(portfolioIDs),
  }).then((res) =>
    res.value.blob().then((xls) => {
      const blob = new Blob([xls], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `rialto_asset_leads_export_${moment().format("L")}.xlsx`);
    })
  );
};
